import React from 'react';
import PropTypes from 'prop-types';
import './LoginButtons.css';
import facebookImage from './facebook-login.png';
import googleImage from './google-login.png';

export const LoginWithGoogleButton = (props) => (
  <button {...props} className="LoginSocialButton LoginWithGoogleButton">
    <div className="LogoContainer GoogleLogoContainer">
      <img src={googleImage} alt="Google logo" />
    </div>
    <span>Ingresar con Google</span>
  </button>
);

LoginWithGoogleButton.displayName = 'LoginWithGoogleButton';

LoginWithGoogleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const LoginWithFacebookButton = (props) => (
  <button {...props} className="LoginSocialButton LoginWithFacebookButton">
    <div className="LogoContainer FacebookLogoContainer">
      <img src={facebookImage} alt="Facebook logo" />
    </div>
    <span>Ingresar con Facebook</span>
  </button>
);

LoginWithFacebookButton.displayName = 'LoginWithFacebookButton';

LoginWithFacebookButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
